import { tv } from '@change/ds-utils';

export const FooterStyles = tv({
	base: 'flex flex-row items-center justify-center gap-2 bg-[#403A49]',
	variants: {
		size: {
			small: 'gap-1 px-1.5 py-1',
			medium: 'px-[8.5px] py-2',
			large: 'px-3 py-2.5',
		},
	},
});

export const RectangleShapeStyles = tv({
	base: '',
	variants: {
		size: {
			small: 'h-2.5 w-[60px]',
			medium: 'h-[21px] w-[124px]',
			large: 'h-6 w-[145px]',
		},
	},
});
